<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ selectedContract ? 'Veicolo: ' + selectedContract.alias : 'Veicoli: Tutti' }}
        <div style="float:right;">
          <small><b>Centra&nbsp;&nbsp;</b></small>
          <c-switch color="success" label size="sm" class="float-right" checked v-model="center" @change="centerChange" />
        </div>
      </div>
      <div id="map_canvas" style="height: 600px"></div>
    </b-card>
  </div>
</template>

<script>
import Vue from 'vue';
import JQuery from 'jquery'
let $ = JQuery
import AddressGeocoder from '@/components/AddressGeocoder.vue';
import { Switch as cSwitch } from '@coreui/vue'

export default {
  name: 'vehicles',
  components: {
    AddressGeocoder,
    cSwitch
  },
  data () {
    return {
      map: null,
      center: true,
      markers: {},
      center: {lat: 45.6, lng: 8.7},
      selectedMarker: null,
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      infoWinOpen: false,
      currentMidx: null,
      // optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    }
  },
  mounted() {
    console.log('mounted');
    this.infowindow = new google.maps.InfoWindow({
      size: new google.maps.Size(150, 50)
    })

    // google.maps.event.addDomListener(window, "load", this.initialize)
    let latlng = new google.maps.LatLng(45.6, 8.7)
    let mapOptions = {
      zoom: 10,
      center: latlng,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }
    this.map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);
    google.maps.event.addListener(this.map, 'click', () => {
      this.infowindow.close()
    });

    this.loadContracts(true);
  },
  methods: {
    centerChange() {
      if (this.center) {
        this.rebounds();
      }
    },
    loadContracts(rebounds) {
      this.$store.getters.filteredContracts.forEach(data => {
        let marker = this.markers[data.id];
        if (!marker) {
          marker = this.createMarker(data);
          this.markers[data.id] = marker;
        } else {
          const newLatLng = new google.maps.LatLng(data.livemonitor.latitude, data.livemonitor.longitude);
          if (!marker.getPosition().equals(newLatLng)) {
            marker.setPosition(newLatLng);
            $(marker.label.labelDiv_).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200);
          }
        }
      });
      if (rebounds) {
        this.rebounds();
      }
    },
    createMarker(data) {
        let latLng = new google.maps.LatLng(data.livemonitor.latitude, data.livemonitor.longitude);
        let labelClass = (data.livemonitor.inputStatus & 0x01) == 0x01 ? 'markerlabel-green' : 'markerlabel-red';
        let labelContent = '&nbsp;' + data.alias + '&nbsp;';
        let icon = {
          url: 'img/map/' + data.color + '/' + data.vehicleType + '.png',
          size: new google.maps.Size(35, 37),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(16, 35)
        };
        let marker = new MarkerWithLabel({
            position: latLng,
            map: this.map,
            icon: icon,
            title: data.alias,
            labelContent: labelContent,
            labelAnchor: new google.maps.Point((labelContent.length - 11) * 3, -2),
            labelClass: labelClass,
            labelStyle: {
                opacity: 0.95
            },
            // gt: {
            //     color: color,
            //     style: style,
            //     codper: codper,
            //     selected: false
            // }
        });

        // var content = getHtmlInfowindow(item);
        //
        // marker.gt.infowindow = new google.maps.InfoWindow();

        // google.maps.event.addListener(marker, 'click', function() {
        //     closeAllInfoWin();
        //     selectMarker(marker);
        //     marker.gt.infowindow.setContent('');
        //     marker.gt.infowindow.open(map, marker);
        //     marker.gt.infowindow.setContent(content);
        //     $('.infowintabs').tabs();
        // });
        //
        // google.maps.event.addListener(marker.gt.infowindow, 'closeclick', function() {
        //     //            reboundsMap();
        //     $('.infowintabs').tabs( "destroy" );
        // });
        //        google.maps.event.addListener(marker, 'position_changed', function() {
        //            //$(marker.label.labelDiv_).fadeOut(200).fadeIn(200).fadeOut(200).fadeIn(200);
        //        });

        return marker;
    },
    rebounds: function () {
      if (Object.keys(this.markers).length === 0) { return; }

      const bounds = new google.maps.LatLngBounds();
      for (var k in this.markers){
        if (this.markers.hasOwnProperty(k)) {
          bounds.extend(this.markers[k].position);
        }
      }
      this.map.fitBounds(bounds); //, {padding: [200, 200]});
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.selectedMarker = marker;
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        // if different marker set infowindow to open and reset current marker index
        this.currentMidx = idx
        this.infoWinOpen = true
      }
    }
  },
  computed: {
    selectedContract() {
      return this.$store.getters.selectedContract;
    },
    contracts() {
      return this.$store.getters.filteredContracts;
    },
  },
  watch: {
    contracts (newContracts, oldContracts) {
      if (oldContracts.length === 0) {
        this.loadContracts(true);
      } else if (newContracts.length === 1 && oldContracts.length === 1) {
        const newLatLng = new google.maps.LatLng(newContracts[0].livemonitor.latitude, newContracts[0].livemonitor.longitude);
        if (!this.markers.hasOwnProperty(newContracts[0].id)) { // change from 1 to another 1
          this.markers[oldContracts[0].id].setMap(null);
          this.markers = {};
          this.loadContracts(false);
          this.map.panTo(newLatLng);
          this.map.setZoom(18);
        } else { // same contract
          this.loadContracts(false);
          if (this.center) {
            this.map.panTo(newLatLng);
          }
        }
      } else if (newContracts.length === 1 && oldContracts.length > 1) { // change from many to 1
        for (var k in this.markers){
          if (this.markers.hasOwnProperty(k)) {
            this.markers[k].setMap(null);
          }
        }
        this.markers = {};
        this.loadContracts(true);
        this.map.setZoom(18);
      } else if (oldContracts.length === 1 && newContracts.length > 1) { // change from 1 to many
        this.loadContracts(true);
      } else { // all contract
        this.loadContracts(this.center);
      }
    },
  }
}
</script>

<style>
.markerlabel-green {
    white-space:nowrap;
    background-color: #00FF00;
    color: black;
    border: 1px solid black;
    font-weight: bold;
    font-size: 10px;
}

.markerlabel-red {
    white-space:nowrap;
    background-color: #FF0000;
    color: white;
    border: 1px solid white;
    font-weight: bold;
    font-size: 10px;
}
</style>
